export default function () {
  return {
    loading: false,
    currentUser: {},
    banner: {
      show: false,
      variant: 'success',
      message: '',
    },
    notifications: {
      lockedUsers: [],
      supportRequests: [],
    },

    showSsoSyncBanner: false,

    redemption: {
      redemptionCode: '',
      canGetAdditionalCodes: false,
    },
    offlineStatus: {},

    bannerMessages: [],

    marketingMessages: [],
  };
}
